<template>
    <div class="business">
        <!-- banner图 -->
        <section class="banner">
            <el-button style="min-width: 160px; color: #22AA56; font-size: 18px;" size="default" @click.stop="handleFreeBtnClick">免费定制</el-button>
        </section>
        <!-- 卡片 -->
        <section class="card-container">
            <div class="card-list">
                <div class="card">
                    <img src="@/assets/img/homes/business/medicine-chest.png" alt="medicine-ches"/>
                    <h3 class="title">医药卫生</h3>
                    <div class="desc">
                        <span class="count">1500万</span>道测试题
                    </div>
                    <div class="desc">
                        <span class="count">17万</span>套试卷
                    </div>
                </div>
                <div class="card">
                    <img src="@/assets/img/homes/business/buiding.png" alt="medicine-ches"/>
                    <h3 class="title">建筑工程</h3>
                    <div class="desc">
                        <span class="count">310万</span>道测试题
                    </div>
                    <div class="desc">
                        <span class="count">3万</span>套测试卷
                    </div>
                </div>
                <div class="card">
                    <img src="@/assets/img/homes/business/paper-money.png" alt="medicine-ches"/>
                    <h3 class="title">财会经济</h3>
                    <div class="desc">
                        <span class="count">390万</span>道测试题
                    </div>
                    <div class="desc">
                        <span class="count">4万</span>套试卷
                    </div>
                </div>
                <div class="card">
                    <img src="@/assets/img/homes/business/exam.png" alt="medicine-ches"/>
                    <h3 class="title">公职考试</h3>
                    <div class="desc">
                        <span class="count">300万</span>道测试题
                    </div>
                    <div class="desc">
                        <span class="count">3万</span>套试卷
                    </div>
                </div>
                <div class="card">
                    <img src="@/assets/img/homes/business/computer.png" alt="medicine-ches"/>
                    <h3 class="title">计算机</h3>
                    <div class="desc">
                        <span class="count">290万</span>道测试题
                    </div>
                    <div class="desc">
                        <span class="count">3万</span>套试卷
                    </div>
                </div>
                <div class="card">
                    <img src="@/assets/img/homes/business/english.png" alt="medicine-ches"/>
                    <h3 class="title">语言类</h3>
                    <div class="desc">
                        <span class="count">80万</span>道测试题
                    </div>
                    <div class="desc">
                        <span class="count">1万</span>套试卷
                    </div>
                </div>
            </div>
            <button class="btn-reset btn" @click.stop="handleFreeBtnClick">任选一类，专属定制 <i class="el-icon-right"></i></button>
        </section>
        <!-- 我们的优势 -->
        <section class="advantage">
            <div class="text-center">
                <img src="@/assets/img/homes/business/advantage.png" alt="advantage" class="title">
            </div>
            <div class="card-list">
                <div class="card card-questions">
                    <div class="title-container">
                        <img src="@/assets/img/homes/business/questions.png" alt="question-assets"/>
                        <div>
                            <h3 class="title">海量题库资源</h3>
                            <span class="en-title">Question bank configuration</span>
                        </div>
                    </div>
                    <div class="desc">
                        试题量超2200万道，真题模拟试卷40万余套，十一大分类涵盖公务员、工程类、语音类等，可以帮助机构打造专属的题库。
                    </div>
                </div>
                <div class="card card-auto-exam">
                    <div class="title-container">
                        <img src="@/assets/img/homes/business/auto-exam-org.png" alt="auto-exam-org"/>
                        <div>
                            <h3 class="title">自主考试组织</h3>
                            <span class="en-title">Custom development</span>
                        </div>
                    </div>
                    <div class="desc">
                        机构可通过平台自主组织考试，平台实现从出题、组卷、监考、阅卷、统计全流程管理。
                    </div>
                </div>
                <div class="card card-question-processing">
                    <div class="title-container">
                        <img src="@/assets/img/homes/business/question-processing.png" alt="question-assets"/>
                        <div>
                            <h3 class="title">试题加工服务</h3>
                            <span class="en-title">Question bank processing</span>
                        </div>
                    </div>
                    <div class="desc">
                        纸质、图片等格式的试题资源平台进行免费加工录入。
                    </div>
                </div>
            </div>
            <button class="btn-reset btn" @click.stop="handleFreeBtnClick">专属定制<i class="el-icon-right" style="margin-left: 40px"></i></button>
        </section>
        <!-- 医疗行业案例 -->
        <section class="medical">
            <div class="text-center">
                <img src="@/assets/img/homes/business/medical-industry.png" alt="medical-industry"/>
            </div>
            <div class="banner">
                <div class="count">
                    <span>1200万</span>道试题，<span>14万</span>套试卷
                </div>
                <div class="border-line"></div>
                <div class="desc">海量医学题库资源｜医疗机构考核培训服务</div>
                <button class="btn-reset yixue-btn"
                        @click.stop="handleOpenMedicine"
                        @mouseleave.stop="onBtnMouseleave"
                        @mouseenter.stop="onBtnMouseenter">{{ btnText }}
                </button>
                <button class="btn-reset free-btn" @click.stop="handleFreeBtnClick">免费试用</button>
            </div>
            <div class="menu-list">
                <div class="menu" v-for="(item, index) in departments.slice(0, 9)"
                     :key="item.id"
                     @click.stop="handleDepartmentClick(item, index)"
                     :class="{'is--active': currentMedicalItem === index}">
                    {{item.HospitalClassName}}
                </div>
                <div class="menu" v-if="departments.length > 9" @click.stop="handleOpenMedicine">
                    更多
                </div>
            </div>
            <div class="menu-desc">
                <div class="count">总试题量：<span>{{departmentDesc.SubjectCount}} 道</span></div>
                <div class="remark">{{departmentDesc.Remark}}</div>
            </div>
            <div class="child-menu">
                <div class="child-menu-item" v-for="item in departmentChild.slice(0, 5)" :key="item.id">
                    <div class="title">{{item.HospitalClassName}}</div>
                    <div class="count">试题：<span>{{item.SubjectCount}}道</span></div>
                </div>
                <div class="child-menu-item more" v-if="departmentChild.length > 5" @click.stop="handleOpenMedicine">进入主页，查看更多</div>
            </div>
            <div class="card-list">
                <div class="card">
                    <img src="@/assets/img/homes/business/question-org.png" alt="question-org"/>
                    <h3 class="title">自建题库组织</h3>
                    <div class="desc">
                        机构管理员通过自建试题、自建试卷等模块，方便机构对自有资源随时进行调用、检索，从而助力机构打造专属的特色题库资源库。
                    </div>
                </div>
                <div class="card">
                    <img src="@/assets/img/homes/business/collage-exam.png" alt="collage-exam"/>
                    <h3 class="title">院内自主考试</h3>
                    <div class="desc">医院可在平台进行招聘考试、院感考试、三基考试、住院医师规培等考试，方便医院可自行灵活组织各项考试。</div>
                </div>
                <div class="card">
                    <img src="@/assets/img/homes/business/project-manage.png" alt="project-manage"/>
                    <h3 class="title">课程学习管理</h3>
                    <div class="desc">课程学习管理可以对学生的学习情况、学分记录进行统计，从而达到课程学习流程化、规范化的高效学习的目的。</div>
                </div>
            </div>
        </section>
        <!-- 典型用户 -->
        <section class="typical">
            <div class="text-center title">
                <img src="@/assets/img/homes/business/typical.png" alt="typical-user"/>
            </div>
            <div class="collage-list">
                <div>
                    <img alt="" src="@/assets/img/homes/business/hebei.png"/>
                </div>
                <div>
                    <img alt="" src="@/assets/img/homes/business/beijing.png"/>
                </div>
                <div>
                    <img alt="" src="@/assets/img/homes/business/xiangnan.png"/>
                </div>
                <div>
                    <img alt="" src="@/assets/img/homes/business/tianjin.png"/>
                </div>
                <div><img alt="" src="@/assets/img/homes/business/jishou.png"/></div>
                <div><img alt="" src="@/assets/img/homes/business/xinan.png"/></div>
                <div><img alt="" src="@/assets/img/homes/business/shengjing.png"/></div>
                <div><img alt="" src="@/assets/img/homes/business/shantou.png"/></div>
                <div><img alt="" src="@/assets/img/homes/business/liuzhou.png"/></div>
                <div><img alt="" src="@/assets/img/homes/business/sichuang.png"/></div>
                <div><img alt="" src="@/assets/img/homes/business/liuzhou-people.png"/></div>
                <div><img alt="" src="@/assets/img/homes/business/fujian.png"/></div>
            </div>
        </section>
        <Dialog ref="dialog"/>
    </div>
</template>

<script>
import { GetQuestionTypeCountNew, GetQuestionChildTypeCountNew } from "@/api/course"
import Dialog from "./cpns/Dialog"
export default {
    name: "Business",
    data() {
        return {
            btnText: "yixue.cqvip.com",
            currentMedicalItem: 0,
            departments: [], // 部门
            departmentChild: [] // 子部门
        }
    },
    components: {
        Dialog
    },
    created() {
        this.getDepartment()
    },
    computed: {
        departmentDesc ({ currentMedicalItem, departments }) {
            return departments[currentMedicalItem] || {}
        }
    },
    methods: {
        onBtnMouseleave() {
            this.btnText = "yixue.cqvip.com"
        },
        onBtnMouseenter() {
            this.btnText = "立即查看"
        },
        handleFreeBtnClick () {
            this.$refs.dialog.open()
        },
        handleOpenMedicine () {
            window.open(window.location.protocol + "//yixue.cqvip.com/#/")
        },
        // 获取部门
        getDepartment () {
            GetQuestionTypeCountNew().then(res => {
                this.departments = Array.isArray(res.data.data) ? res.data.data : this.departments
                if (this.departments.length !== 0) {
                    this.getChildDepartment(this.departments[0].Id)
                }
            })
        },
        // 获取当前部门下的子部门
        getChildDepartment (typeId) {
            GetQuestionChildTypeCountNew({ typeId }).then(typeCount => {
                this.departmentChild = Array.isArray(typeCount.data.data) ? typeCount.data.data : []
            })
        },
        handleDepartmentClick (item, index) {
            this.currentMedicalItem = index
            this.getChildDepartment(item.Id)
        }
    }
}
</script>

<style scoped lang="less">
@import "../index.less";

.business {
    background-color: #fff;
}

.banner {
    width: 100%;
    background-image: url("~@/assets/img/homes/business/banner.png");
    background-position: left top;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    height: 588px;
    padding-left: @base-padding * 2;
    box-sizing: border-box;
    padding-top: 350px;
}

.btn {
    background-color: #29CC89;
    color: #fff;
    min-width: 327px;
    height: 60px;
    font-size: 18px;
    display: block;
    margin: 60px auto 0;
}

.card-container {
    box-sizing: border-box;
    padding: 53px @base-padding 0;
    border-radius: 53px 53px 0 0;
    position: relative;
    top: -68px;
    z-index: 1;
    background-color: #fff;

    .card-list {
        display: grid;
        grid-gap: 62px;
        grid-template-columns: repeat(6, 1fr);
        grid-template-rows: auto;
        box-sizing: border-box;

        .card {
            background-color: #EFF2F6;
            border-radius: 40px 0 40px 40px;
            text-align: center;
            padding: 30px 0;
            box-sizing: border-box;
            border: 6px solid #fff;
            transition: all .2s linear;
            cursor: pointer;
            position: relative;
            &:hover {
                border-color: #29CC89;
                transform: scale(1.03);
                top: -2px;
            }
            .title {
                margin-top: 24px;
                padding: 0;
                font-size: 20px;
            }

            .desc {
                margin-top: 12px;
                font-size: 14px;

                .count {
                    color: #F7593B;
                    font-size: 16px;
                    font-weight: 600;
                    margin-right: 4px;
                }
            }
        }
    }
}

.advantage {
    width: @type-area-width;
    margin: 0 auto;
    box-sizing: border-box;

    .card-list {
        display: grid;
        grid-template-rows: auto;
        grid-template-columns: repeat(3, 1fr);
        box-sizing: border-box;
        margin-top: 43px;
        grid-gap: 30px;

        .card {
            border-radius: 26px;
            padding: 40px 60px;
            color: #fff;

            &.card-questions {
                background: linear-gradient(316deg, #14B379 0%, #44EA9A 100%);
            }

            &.card-auto-exam {
                background: linear-gradient(316deg, #FDA425 0%, #FFBF00 100%);
            }

            &.card-question-processing {
                background: linear-gradient(316deg, #246DE1 0%, #489EE5 100%);
            }

            .title-container {
                display: flex;
                justify-content: space-between;

                .title {
                    font-size: 22px;
                    margin: 0 0 15px 0;
                }

                .en-title {
                    font-size: 16px;
                    font-weight: normal;
                }
            }

            .desc {
                line-height: 30px;
                margin-top: 43px;
                font-size: 18px;
            }
        }

    }
}

.medical {
    box-sizing: border-box;
    margin-top: 68px;

    .banner {
        width: calc(100% - @base-padding);
        margin: 0 auto;
        background-image: url("~@/assets/img/homes/business/medical-banner.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: left top;
        height: 711px;
        box-sizing: border-box;
        padding-left: calc(@base-padding - (@base-padding / 5));
        padding-top: @base-padding + (@base-padding / 2);

        .count {
            font-size: 24px;
            color: #fff;
            margin-bottom: 20px;
            margin-top: 10px;

            > span {
                color: #FFF94C;
                font-weight: 700;
            }
        }

        .border-line {
            width: 378px;
            height: 3px;
            background-image: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
            margin-bottom: 20px;
        }

        .desc {
            font-size: 15px;
            color: #fff;
            margin-bottom: 20px;
        }

        .yixue-btn {
            color: #FFF94C;
            border: 2px solid #FFF94C;
            padding: 20px 30px;
            background-color: rgba(255, 255, 255, 0);
            font-size: 20px;
            margin-top: 54px;
            min-width: 220px;

            &:hover {
                color: #29CC89;
                background-color: #FFF94C;
            }
        }

        .free-btn {
            min-width: 220px;
            color: #29CC89;
            border: 2px solid #FFF94C;
            padding: 20px 30px;
            background-color: #FFF94C;
            font-size: 20px;
            margin-top: 54px;
            margin-left: 20px;
        }
    }
    .card-list {
        width: @type-area-width;
        margin: 66px auto 0;
        display: flex;
        justify-content: space-between;
        text-align: center;
        .card {
            width: 32%;
            background-color: #F8FAFE;
            padding: 40px 30px;
            box-sizing: border-box;
            border-radius: 26px;
            backdrop-filter: blur(6px);
            .title {
                font-size: 22px;
                margin: 58px 0 30px;
            }
            .desc {
                font-size: 16px;
                line-height: 30px;
                text-align: left;
            }
        }
    }
    .menu-list {
        width: @type-area-width;
        margin: 43px auto 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .menu {
            min-width: 9%;
            box-sizing: border-box;
            padding: 0 40px;
            height: 110px;
            line-height: 96px;
            background-image: url("~@/assets/img/homes/business/triangle-bg.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-position: left top;
            font-size: 16px;
            text-align: center;
            cursor: pointer;
            transition: all .3s ease-in-out;
            &.is--active {
                background-image: url("~@/assets/img/homes/business/triangle-bg-active.png");
                color: #fff;
                &:hover {
                    color: #fff;
                }
            }
            &:hover {
                color: #29CC89;
            }
        }
    }
    .menu-desc {
        width: @type-area-width;
        margin: 0 auto;
        background-color: #00B37C;
        color: #fff;
        box-sizing: border-box;
        padding: 40px;
        border-radius: 12px;
        .count {
            margin-bottom: 40px;
            font-size: 16px;
            >span {
                font-size: 20px;
            }
        }
        .remark {
            line-height: 36px;
            font-size: 15px;
        }
    }
    .child-menu {
        width: @type-area-width;
        margin: 33px auto 0;
        display: flex;
        &-item {
            min-width: 16%;
            background-color: #F0F3F7;
            border-radius: 32px;
            box-sizing: border-box;
            height: 96px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            text-align: center;
            margin-right: 0.6%;
            border: 6px solid #fff;
            cursor: pointer;
            transition: all .2s ease;
            .title {
                font-size: 16px;
                margin-bottom: 10px;
            }
            .count {
                font-size: 16px;
                >span {
                    font-size: 20px;
                    color: #29CC89;
                }
            }
            &:hover {
                border-color: #29CC89;
            }
            &.more {
                margin-right: 0;
                border-color: #29CC89;
                font-size: 16px;
                color: #29CC89;

                &:hover {
                    background-color: #29CC89;
                    color: #fff;
                    border-color: rgba(41, 204, 76, 0.99);
                }
            }
        }
    }
}

.typical {
    width: @type-area-width;
    margin: 68px auto 0;

    .title {
        margin-bottom: 68px;
    }

    .collage-list {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-template-rows: auto;
        grid-gap: 20px;

        img {
            width: 100%;
        }
    }
}

</style>
